// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { SlicePipe } from '@angular/common';
import {
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ModalDirective, ModalInterfaceComunication } from '../../modal-overlay/modal.directive';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../popup-feedback/popup-feedback.directive';

@Component({
  selector: 'lbca-textarea-condensed',
  templateUrl: './textarea-condensed.component.html',
  styleUrl: './textarea-condensed.component.scss',
  imports: [SlicePipe],
})
export class TextareaCondensedComponent implements OnInit, OnDestroy {
  private overlay = inject(Overlay);
  private router = inject(Router);

  private popupFeedController = new PopupInterfaceCommunication();

  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );

  @ViewChild('templateCopy') templateCopy!: TemplateRef<any>;

  private modalController = new ModalInterfaceComunication();

  @HostBinding('attr.lbcaControllerModal') lbcaModal = new ModalDirective(
    this.overlay,
    this.modalController
  );

  @ViewChild('textAreaSupport') textAreaSupport!: TemplateRef<any>;

  public lane: any;
  public labelValue: string = '';
  public valueToReturn: any = '';
  dataPrazo: any;

  subscription!: Subscription;

  @Input() set laneData(lane: string) {
    this.lane = lane;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set value(value) {
    this.valueToReturn = value;
  }

  ngOnInit() {
    this.subscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((val) => this.modalController.closeModal());
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  public openModal(): void {
    this.modalController.showModal(this.textAreaSupport);
    // this.dataPrazo = moment.unix(this.lane['data-prazo']).format('LL');
    this.dataPrazo = moment(this.lane['data-prazo']).format('LL');
  }

  public closeModal(): void {
    this.modalController.closeModal();
  }

  getInicials(name: string) {
    const nameTreatment = name || 'Usuario Teste';
    const nameSplited: Array<string> = nameTreatment.split(' ');
    if (nameSplited.length > 1) {
      return nameSplited[0].slice(0, 1).toUpperCase() + nameSplited[1].slice(0, 1).toUpperCase();
    } else {
      return nameSplited[0].slice(0, 2).toUpperCase();
    }
  }

  public copyToClipboard($event): void {
    $event.preventDefault();
    $event.stopPropagation();
    navigator.clipboard.writeText(this.valueToReturn).then(() => {
      this.popupFeedController.show(this.templateCopy);
      setTimeout(() => this.popupFeedController.close(), 4000);
    });
  }
}
